import { render, staticRenderFns } from "./manage-whitelisting-modal.vue?vue&type=template&id=24f97f3e"
import script from "./manage-whitelisting-modal.vue?vue&type=script&lang=js"
export * from "./manage-whitelisting-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports